import {Swiper, SwiperSlide} from "swiper/react";
import {EffectCoverflow, Pagination} from "swiper/modules";
import {useEffect, useRef, useMemo} from "react";
import { useSize } from 'ahooks'
import "swiper/css";
import "./index.less";
import RedotpayCard from "@/components/RedotpayCard";
import {useSelector} from "react-redux";
import {Typography, Box} from "@mui/material";
import Empty from "@/components/Empty.tsx";
import useSettings from "@/hook/useSettings";

export default function CardWrapper({onChange, cards, focusedCardId}) {
  const {list} = useSelector(state => state.card);

  const ref = useRef(null);
  const size = useSize(document.querySelector('body'));

  const { settings } = useSettings();

  useEffect(() => {
    if (focusedCardId) {
      const idx = list.findIndex((item) => item.cardId === focusedCardId);
    }
  }, [focusedCardId]);

  const initialSlide = useMemo(() => {
    if (!cards) return 0;
    if (!focusedCardId) return 0;
    const idx = list.findIndex((item) => item.cardId === focusedCardId);
    return idx > 0 ? idx : 0;
  }, [cards, focusedCardId])

  useEffect(() => {
    if (!list || list.length <= 0) {
      return
    }
    onChange && onChange(list[initialSlide]);
  }, [initialSlide]);

  useEffect(() => {
    if (cards && cards.length > 0 && !focusedCardId) {
      if (onChange) onChange(list[0]);
    }
  }, [cards]);

  const _onSwiperChange = (e) => {
    if (onChange) onChange(list[e.activeIndex]);
  }

  if ((cards && !cards.length)) {
    return <Empty/>
  }

  // const cardHeight = useMemo(() => {
  //   const scale = size?.width / 375
  //   return 201 * scale
  // }, [size])
  //
  const cardScale = useMemo(() => {
    const scale = size?.width / 375
    return scale
  }, [size])

  return (
    <Box>
      <Box
        ref={ref}
        sx={theme => {
          return {
            boxSizing: 'content-box',
            // width: theme.typography.pxToRem(343), //'343px',
            height: 201 * cardScale + 'px', //theme.typography.pxToRem(), // '201px',
            maxHeight: 201 * (520 / 375) + 'px',
            paddingBottom: '24px',
            overflow: 'visible',
          }
        }}
      >
        <Swiper
          initialSlide={initialSlide}
          // effect={"coverflow"}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={"auto"}
          dir={settings.direction}
          key={`${settings.direction}-swiper`}
          watchOverflow
          observer={'true'}
          // loop={true}
          // coverflowEffect={{
          //   scale: 0.8,
          //   rotate: 0,
          //   stretch: 0,
          //   depth: 100,
          //   modifier: 1,
          //   slideShadows: false,
          // }}
          pagination={true}
          // modules={[EffectCoverflow, Pagination]}
          modules={[Pagination]}
          className="mobile-swiper-wraper"
          onActiveIndexChange={_onSwiperChange}
        >
          {cards && cards.length > 0 && cards.map((item) => (
            <SwiperSlide
              style={{transform: `scale(0.99)` }}
              key={item.cardId} >
              <RedotpayCard cardItem={item}/>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </Box>
  );
}
